import React from 'react';
import css from './ListingPage.module.css';
// import { ListSlider } from '../../components';
import { useListingPageContext } from './context/ListingPageContext';
import { cardRenderSizes, isArrayLength } from '../../util/genericHelpers';

import Slider from 'react-slick';
import '../../styles/slick/slick.css';
import '../../styles/slick/slick-theme.css';
import { ListingCard } from '../../components';
const AuthorListingsSection = props => {
  const { viewport, listings } = props;
  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1128,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div className={css.moreItemSeller}>
      <h2 className={css.sectionTitle}>More items by this seller</h2>
      <Slider {...sliderSettings} arrows={!isMobileLayout}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(false)}
            // setActiveListing={setActiveListing}
          />
        ))}
      </Slider>
      {/* {isArrayLength(authorListings) ? (
        <>
          <ListSlider
            title="ListingPage.moreItemsByTheAuthor"
            viewport={viewport}
            listings={authorListings || []}
            intl={intl}
            sliderHeading={css.sliderHeading}
            homeMobileSlider={css.homeMobileSlider}
            isAuthenticated={isAuthenticated}
            isListingPageSlider={true}
            isOwnListing={isOwnListing}
            currentUser={currentUser}
          />
        </>
      ) : null} */}
    </div>
  );
};

export default AuthorListingsSection;
